import MenuBox from './MenuBox'


const MainMenu = ({ isMobile }) => {
    return (
        <>
        <MenuBox isMobile={isMobile} />
        </>
    );
};

export default MainMenu;